import { Node } from "../node";
import { Abacus } from "./density.aware.spray.and.wait/abacus";

export class Message {

    id: number;

    // Exact creation time, UTC timestamp in milliseconds.
    creationTime: number;
    arrivalTime: number|null = null;
    timeTakenToArrive: number|null = null;

    source: Node;
    destination: Node;
    size: number;

    currentNode: Node;

    abacus: Abacus|undefined
    
    // Which nodes have already got a copy of the message? Should not be sent twice to the same node.
    nodesAlreadyReceived: Array<Node> = [];

    routeTaken: Array<Node> = [];

    constructor(id: number, source: Node, destination: Node, size: number, abacus?: Abacus) {
        this.id = id;
        this.creationTime = Date.now();
        this.source = source;
        this.destination = destination;
        this.size = size;

        if(abacus != undefined) {
            this.abacus = abacus;
        }

        // starts at source node
        this.currentNode = this.source;

        this.nodesAlreadyReceived.push(this.source);
        this.routeTaken.push(this.source);
    }


    toString() {
        return '(' + this.source.id + ' => ' + this.destination.id + ')';
    }
    



}